const admission = {
  // HeroSection
  'admission.hero.homeLink': 'Home',
  'admission.hero.currentPage': 'Admission Guide',
  'admission.hero.imgAlt': 'A butler standing in a posture of welcome and guidance',

  // breadcrumb
  'admission.breadcrumb.home': 'Home',
  'admission.breadcrumb.current': 'Admission Guide',

  // AdmissionFlow
  'admission.flow.label': 'ADMISSION FLOW',
  'admission.flow.title': 'Steps to Enrolment',
  'admission.flow.titleEn': 'Steps to Enrolment',
  'admission.flow.lead': 'Joining Japan Butler Academy is straightforward. Start with a brochure or an individual consultation, take your time, and apply when you feel ready.',
  'admission.flow.optionalBadge': 'Optional',
  'admission.flow.requiredBadge': 'Required',

  // GuideCards
  'admission.guide.label': 'NEXT STEPS',
  'admission.guide.title': 'Choose Your Next Step',
  'admission.guide.titleEn': 'Choose Your Path',
  'admission.guide.lead': 'Access the information you need based on where you are in your decision. Unsure? An individual consultation is always available.',
  'admission.guide.arrowLabel': 'Learn more',

  // KeyPoints
  'admission.points.label': 'REQUIREMENTS',
  'admission.points.title': 'Admission at a Glance',
  'admission.points.titleEn': 'Key Admission Points',
  'admission.points.lead': 'The key points to check when considering enrolment. For full details, please refer to the application requirements page.',
  'admission.points.contactNote': 'For full conditions and procedures, please see the',
  'admission.points.contactLink': 'Application Requirements page',
  'admission.points.contactSuffix': '.',

  // ReassuranceSection
  'admission.reassure.label': 'COMMON CONCERNS',
  'admission.reassure.title': 'We Have Answers to Your Concerns',
  'admission.reassure.titleEn': 'Your Questions, Answered',
  'admission.reassure.lead': '"Am I right for this even with no experience?" "Can I manage work and study at the same time?" — Here are our answers to the questions we hear most.',
  'admission.reassure.imgCaption': 'Learn in a warm, welcoming classroom environment — ideal for beginners.',

  // FAQSection
  'admission.faq.label': 'FAQ',
  'admission.faq.title': 'Frequently Asked Questions',
  'admission.faq.titleEn': 'Frequently Asked Questions',
  'admission.faq.contactNote': 'For further enquiries, please use our',
  'admission.faq.contactLink': 'contact form',
  'admission.faq.contactSuffix': '.',

  // CTASection
  'admission.cta.label': 'TAKE THE NEXT STEP',
  'admission.cta.title': 'Your Next Step, at Your Own Pace',
  'admission.cta.lead': 'Whether you prefer to compare brochures first, have a thorough consultation, or apply right away — we have a clear path ready for every stage of your journey.',
  'admission.cta.onlineNote': '* Online consultations are also available.',
  'admission.cta.applyBtn': 'Go to Application Form',
  'admission.cta.brochureBtn': 'Request a Brochure (Free)',
  'admission.cta.consultBtn': 'Book a Consultation',
  'admission.cta.corporateNote': 'Considering this for your company or organisation?',
  'admission.cta.corporateLink': 'See our on-site corporate training',
  'admission.pdfDl.button': 'After you submit your request, we will email you a link to download the guide.',

  // RelatedPages
  'admission.related.label': 'LEARN MORE',
  'admission.related.title': 'Related Pages',
  'admission.related.titleEn': 'Explore Further',
  'admission.related.arrowLabel': 'Learn more',

  // footer
  'admission.footer.lastUpdated': 'Last updated: 13 June 2026',
  'admission.backToTop.ariaLabel': 'Back to top',

  // admissionHero
  'admission.hero.title': 'Admission Guide',
  'admission.hero.lead': 'Joining Japan Butler Academy is straightforward — start with a brochure or individual consultation and proceed at your own pace.',

  // admissionFlowSteps
  'admission.flow.step.0.title': 'Request Brochure',
  'admission.flow.step.0.desc': 'Start with a free brochure for a comprehensive overview of our courses and the academy\'s educational philosophy.',
  'admission.flow.step.1.title': 'Individual Consultation',
  'admission.flow.step.1.desc': 'Our experienced staff will help you find the right course for your goals and experience. Online consultations are available.',
  'admission.flow.step.2.title': 'Apply',
  'admission.flow.step.2.desc': 'Once you have chosen your course, please submit your application via the online form. Places are allocated on a first-come, first-served basis.',
  'admission.flow.step.3.title': 'Enrollment Contract',
  'admission.flow.step.3.desc': 'After your application, we will send you the enrollment agreement. Please review it carefully and complete the contract procedure.',
  'admission.flow.step.4.title': 'Payment',
  'admission.flow.step.4.desc': 'Please transfer the course fee in full by bank transfer no later than 14 days before the start date. Enrollment is confirmed upon receipt of payment.',
  'admission.flow.step.5.title': 'Enrollment Confirmed',
  'admission.flow.step.5.desc': 'Once payment is confirmed, we will contact you with your enrollment confirmation and details of your first class. Your journey begins.',

  // guideCards
  'admission.guide.card.0.title': 'Eligibility & Application Process',
  'admission.guide.card.0.desc': 'Detailed information on eligibility requirements and the step-by-step process from application to enrollment confirmation.',
  'admission.guide.card.0.imgAlt': 'A prospective student holding application documents and a pen',
  'admission.guide.card.1.title': 'Application Form',
  'admission.guide.card.1.desc': 'If you have already decided on your course, you can apply directly here. Complete the required fields — places are allocated on a first-come, first-served basis.',
  'admission.guide.card.1.imgAlt': 'A tablet displaying an open application form',
  'admission.guide.card.2.title': 'Book a Consultation',
  'admission.guide.card.2.desc': '"Which course is right for me?" "I\'d like to find out more first." — We welcome all enquiries in a free, online-available individual consultation.',
  'admission.guide.card.2.imgAlt': 'A visitor and instructor in an individual consultation',
  'admission.guide.card.3.title': 'Trial Seminar',
  'admission.guide.card.3.desc': 'A one-day seminar where you can experience a real class. Get a feel for butler movement and the atmosphere of the academy.',
  'admission.guide.card.3.imgAlt': 'Participants in a practicum session at a trial seminar',

  // keyPoints
  'admission.points.kp.0.label': 'Eligibility',
  'admission.points.kp.0.value': 'Age 18 or above (any nationality, gender, or experience level)',
  'admission.points.kp.1.label': 'Class Size',
  'admission.points.kp.1.value': '6 places per course (first come, first served)',
  'admission.points.kp.2.label': 'Minimum Enrolment',
  'admission.points.kp.2.value': '3 students',
  'admission.points.kp.3.label': 'Payment',
  'admission.points.kp.3.value': 'Bank transfer (lump-sum only)',
  'admission.points.kp.4.label': 'Application Deadline',
  'admission.points.kp.4.value': '14 days before the course start date',
  'admission.points.kp.5.label': 'Class Format',
  'admission.points.kp.5.value': 'Held on weekends, six hours per day (four 90-minute sessions)',
  'admission.points.kp.6.label': 'Venue',
  'admission.points.kp.6.value': 'Aomi, Koto-ku, Tokyo (the Odaiba area)',

  // reassuranceItems
  'admission.reassure.item.0.title': 'No Experience Needed',
  'admission.reassure.item.0.desc': 'All courses warmly welcome beginners. The Essential Course curriculum is designed to build skills step by step from the very basics of movement. Anyone aged 18 or above may enrol — no previous experience or specific background is required.',
  'admission.reassure.item.1.title': 'Study While You Work',
  'admission.reassure.item.1.desc': 'All courses are held on weekends (Saturdays and Sundays), so those in full-time employment can attend without difficulty. \n\nThe Essential Course spans 1 month (8 days), Advanced 2 months (12 days), and Master 3 months (16 days) — enabling structured, plannable study.',
  'admission.reassure.item.2.title': 'Try Before You Commit',
  'admission.reassure.item.2.desc': 'For those unsure about applying straight away, we offer a one-day trial seminar. Our free individual consultation (online available) also allows our experienced staff to answer your questions and concerns at length.',

  // admissionFaqs
  'admission.faq.0.q': 'What is the admission process?',
  'admission.faq.0.a': 'After an optional brochure request and individual consultation, you submit an application form, complete the enrollment contract, make payment, and receive enrollment confirmation.',
  'admission.faq.1.q': 'Is there an entrance examination?',
  'admission.faq.1.a': 'No. Admission is open to anyone aged 18 or above, regardless of experience, on a first-come, first-served basis (6 places per course).',
  'admission.faq.2.q': 'Can I just come in for a consultation first?',
  'admission.faq.2.a': 'Yes. We offer a free individual consultation, also available online. You can also experience a real class at our trial seminar.',
  'admission.faq.3.q': 'Are there age or experience requirements?',
  'admission.faq.3.a': 'Anyone aged 18 or over may enrol, regardless of nationality, gender, or experience. The Essential Course is designed for beginners, so those with no experience can learn step by step from the foundations.',
  'admission.faq.4.q': 'What is the schedule and format of the classes?',
  'admission.faq.4.a': 'Classes are held on weekends, with in-person sessions of six hours per day (four 90-minute sessions), in a hybrid format combined with on-demand preparation and review videos. The campus is in Aomi, Koto-ku, Tokyo (the Odaiba area).',
  'admission.faq.5.q': 'What happens if a course does not reach capacity?',
  'admission.faq.5.a': 'Each course requires a minimum of three students to run. If three students are not reached by 14 days before the start date, you may choose a full refund of the course fee or a transfer to the next term (with a 5% preferential discount).',

  // admissionRelatedPages
  'admission.related.0.title': 'Eligibility & Application Process',
  'admission.related.0.desc': 'Eligibility and application steps',
  'admission.related.1.title': 'Application Form',
  'admission.related.1.desc': 'Apply for a main course',
  'admission.related.2.title': 'Book a Consultation',
  'admission.related.2.desc': 'Free, online-available consultation',
  'admission.related.3.title': 'Trial Seminar',
  'admission.related.3.desc': 'Experience butler movement in a one-day seminar',
  'admission.related.4.title': 'Courses Overview',
  'admission.related.4.desc': 'Compare all three courses at a glance',
};

export default admission;
